import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { ReactiveFormsModule } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { ErrorPageComponent } from '@app/shared/errors/error-page/error-page.component';
import { MatButtonModule } from '@angular/material/button';
import { RouterModule } from '@angular/router';

@NgModule({
  declarations: [ErrorPageComponent],
  imports: [CommonModule, TranslateModule, ReactiveFormsModule, MatFormFieldModule, MatButtonModule, RouterModule],
  exports: [ErrorPageComponent],
})
export class ErrorPageModule {}
